module.exports = __webpack_public_path__ + "static/07-02fae88bb2e734844165e54f51ffe234.png";